﻿window.cResizeObserver = function () {

    //var isObserving = true
    const ro = new ResizeObserver(entries => {
        //if (!isObserving) return;
        //isObserving = false;
        //setTimeout(() => {
        //    isObserving = true;
        //}, 0);

        var lstElementToRemove = []
        for (let entry of entries) {
            var $Ele = lstElementObserver.filter(function (o) { return o.is($(entry.target)) })[0]
            if (typeof $Ele != 'undefined') {
                if ($Ele.closest("body").length > 0) {
                    var sizeNew = { width: $Ele.innerWidth(), height: $Ele.innerHeight() }
                    if (sizeNew.width != $Ele.sizeAvant.width || sizeNew.height != $Ele.sizeAvant.height) {
                        $Ele.sizeAvant = sizeNew
                        $Ele.funcResize()
                    }
                } else {
                    $Ele.nbSansBody += 1
                    if ($Ele.nbSansBody >= 20) {
                        lstElementToRemove.push($Ele)
                    }
                }
            }
        }
        lstElementObserver.forEach(function ($eleObs) {
            if ($eleObs.closest("body").length == 0) $eleObs.nbSansBody += 1
            if ($eleObs.nbSansBody >= 20) {
                lstElementToRemove.push($eleObs)
            }
        })
        lstElementToRemove.forEach(function ($ele) {
            lstElementObserver.splice(lstElementObserver.indexOf($ele), 1)
            console.log("🔝 remove element resizeobserver")
        })
    });
    var lstElementObserver = []

    this.mAdd = function ($Element, func) {
        if (!$.isArray($Element)) $Element = [$Element]
        $Element.forEach(function ($ele) {
            if ($ele.closest("body").length > 0) {
                lstElementObserver.push($ele)
                $ele.sizeAvant = { width: $ele.innerWidth(), height: $ele.innerHeight() }
                $ele.nbSansBody = 0
                $ele.funcResize = func
                try {
                    ro.observe($ele[0]);
                } catch (e) {
                    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                }
            }
        })
        return func
    }
    this.mRemove = function ($Element) {
        //lstElementObserver.splice(lstElementObserver.indexOf($Element), 1)
        if (!$.isArray($Element)) $Element = [$Element]
        $Element.forEach(function ($ele) {
            let idx = lstElementObserver.indexOf($ele);
            if (idx !== -1) {
                lstElementObserver.splice(idx, 1);
                try {
                    ro.unobserve($ele[0]); // 🔑 IMPORTANT
                } catch (e) {
                    console.warn("ResizeObserver unobserve error:", e);
                }
            }
        });
    }

}
window.resizeObserver = new cResizeObserver()